import React from 'react';
import { bool, object } from 'prop-types';
import glamorous from 'glamorous';
import moment from 'moment';

import CSS from './styles.css';
import NoteEditor from 'Components/Notebook/AnnotationList/NoteEditor';

import { ItemEdit as IEIcon } from 'Shared/Icons';
import { Highlight as HIcon } from 'Shared/Icons';
import { More as MRIcon } from 'Shared/Icons';


const CardViews = ({ bodyStyle, cancelEdit, deleteHighlight, addNote, editNote, highlight, isEditingNote, isAddingNote, noteText, saveNote, onKeyDown }) => {
  const showAffordances = () => {
    let editCSS = CSS['edit'];
    let addCSS = CSS['add'];

    if (highlight.noteText) {
      if (isEditingNote) {
        editCSS = `${editCSS} ${CSS['edit__active']}`;
      }

      return (
        <div className={ CSS['card-actions'] }>
          <span id={ `action#${highlight.id}` } className={ editCSS } onClick={ editNote } onKeyDown={ onKeyDown } tabIndex={ isEditingNote ? -1 : 0 }>Edit Note</span>
          <div style={{ width: "15px"}}></div>
          <span id={ `delete#${highlight.id}` } className={ CSS['delete'] } onClick={ deleteHighlight } onKeyDown={ onKeyDown } tabIndex="0">Delete</span>
        </div>
      );
    }

    if (isAddingNote) {
      addCSS = `${addCSS} ${CSS['add__active']}`;
    }

    return (
      <div className={ CSS['card-actions'] }>
        <span id={ `action#${highlight.id}` } className={ addCSS } onClick={ addNote } onKeyDown={ onKeyDown } tabIndex={ isAddingNote ? -1 : 0 }>Add Note</span>
        <div style={{ width: "15px"}}></div>
        <span id={ `delete#${highlight.id}` } className={ CSS['delete'] } style={{ 'marginLeft': 'auto' }} onClick={ deleteHighlight } onKeyDown={ onKeyDown } tabIndex="0">Delete</span>
      </div>
    );
  };

  return (
    <div id={ `card#${highlight.id}` } className={ CSS['card'] } tabIndex="0">

      <div className={ CSS['header'] }>
        {!highlight.noteText
          ? <HIcon fill="#686868" />
          : <IEIcon fill="#686868" />
        }
        {!highlight.noteText
          ? <span className={ CSS['annoType'] }>highlight</span>
          : <span className={ CSS['annoType'] }>highlight and note</span>
        }

        { showAffordances() }
      </div>

      <div className={ CSS['body'] }>
        <div className={ CSS['highlight'] } style={ bodyStyle } tabIndex="0">{ highlight.selectedText }</div>
        {highlight.noteText || isAddingNote
          ? <NoteEditor isEditingNote={ isEditingNote } highlight={ highlight } cancelEdit={ cancelEdit } saveNote={ saveNote } />
          : null
        }
      </div>

      <div className={ CSS['footer'] }>
        <span className={ CSS['last-update'] }>{ moment(highlight.lastModifiedAt).fromNow() }</span>
      </div>
    </div>
  );
};

CardViews.propTypes = {};


export default CardViews;
